import React from "react";

const Technologies = ({ technologies, language }) => {
  const description =
    language === "pl"
      ? technologies.description_pl
      : technologies.description_en;

  return (
    <section id="technologies" className="section">
      <div className="container mx-auto text-center max-w-4xl">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-gradient">
          {language === "pl" ? "Technologie" : "Technologies"}
        </h2>
        <p className="text-gray-400 mb-12 text-lg">{description}</p>
        
        <div className="flex flex-wrap justify-center gap-8">
          {technologies.list.map((tech, index) => (
            <div 
              key={index} 
              className="glass p-6 rounded-xl flex flex-col items-center justify-center w-32 h-32 hover:bg-white/10 transition-all duration-300 hover:-translate-y-2 group"
            >
              <img
                src={tech.logo}
                alt={tech.name}
                className="w-12 h-12 mb-3 object-contain filter drop-shadow-lg group-hover:scale-110 transition-transform"
              />
              <span className="text-sm font-medium text-gray-300 group-hover:text-white">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;
